var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('theme-switcher',{attrs:{"themes":_vm.themes,"active":_vm.activeTheme},on:{"toggle":_vm.toggleTheme}})}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-266b6fb2","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/containers/Navigation/ThemeSwitcherContainer.vue
// module id = null
// module chunks = 